import React from 'react';
import scaleSize from 'utils/scale-size';

export default () => (
  <svg
    width={scaleSize(30)}
    height={scaleSize(25)}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9V3H7V9H3ZM0 12V9V2C0 0.89543 0.895431 0 2 0H28C29.1046 0 30 0.895431 30 2V9V12V18V21V28C30 29.1046 29.1046 30 28 30H2C0.89543 30 0 29.1046 0 28V21V18V12ZM27 12V18H24V16.5V13.5V12H27ZM24 9H27V3H24V9ZM21 3H10V13.5H21V3ZM21 16.5H10V27H21V16.5ZM24 27H27V21H24V27ZM3 27V21H7V27H3ZM7 16.5V18H3V12H7V13.5V16.5Z"
      fill="#9F9F9F"
    />
  </svg>
);
